import { Select } from "@xola/ui-kit";
import { useField } from "formik";
import React, { SelectHTMLAttributes, useContext } from "react";
import { FormFieldContext, useError } from "./FormField";

type SelectProps = SelectHTMLAttributes<HTMLSelectElement>;

export const SelectField = ({ name, ...rest }: SelectProps) => {
    const fieldName = (useContext(FormFieldContext) || name) ?? "";
    const [field, , helpers] = useField(fieldName);
    const error = useError(fieldName);

    const handleOnChange = (e: any) => {
        if (rest.onChange) {
            rest.onChange(e);
        }

        helpers.setValue(e.target.value);
    };

    return <Select isError={!!error} {...field} {...rest} onChange={handleOnChange} />;
};
